import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, getCurrentInstance } from 'vue';
import PaymentTypeRepository from '@/repositories/PaymentTypeRepository';
import BankAccountRepository from '@/repositories/BankAccountRepository';
import CurrencyRepository from '@/repositories/CurrencyRepository';
import { DocumentSendingProfile } from '@/enums/global/DocumentSendingProfile';
import AddressTypeRepository from '@/repositories/AddressTypeRepository';

interface Props {
    taxId: any;
    registerId: any;
    isTaxPayer: any;
    webpage: any;
    bankCode: any;
    currency: any;
    paymentType: any;
    isCompany: any;
    documentSendingProfile: any;
    clientAddresses: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaxesPaymentSection',
  props: {
    taxId: null,
    registerId: null,
    isTaxPayer: null,
    webpage: null,
    bankCode: null,
    currency: null,
    paymentType: null,
    isCompany: null,
    documentSendingProfile: null,
    clientAddresses: null
  },
  emits: ["update:taxId", "update:registerId", "update:isTaxPayer", "update:webpage", "update:bankCode", "update:currency", "update:paymentType", "update:documentSendingProfile"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:taxId', value: string): void;
    (e: 'update:registerId', value: string): void;
    (e: 'update:isTaxPayer', value: boolean): void;
    (e: 'update:webpage', value: string): void;
    (e: 'update:bankCode', value: string): void;
    (e: 'update:currency', value: string): void;
    (e: 'update:paymentType', value: string): void;
    (e: 'update:documentSendingProfile', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    taxId: any;
    registerId: any;
    isTaxPayer: any;
    webpage: any;
    bankCode: any;
    currency: any;
    paymentType: any;
    isCompany: any;
    documentSendingProfile: any;
    clientAddresses: any;
};



// Template refs for validation border styling
const tax = ref<HTMLElement | null>(null);

const validateSendingProfile = (): string | null => {
    const profile = props.documentSendingProfile;
    if (!profile) {
        return null;
    }

    const billingAddress = props.clientAddresses.find((addr: any) => {
        if (!addr.addressType) {
            return false;
        }
        const typeDetails = AddressTypeRepository.getById(addr.addressType);
        return typeDetails?.code?.toLowerCase() === 'billing';
    });

    const defaultAddress = props.clientAddresses.find((a: any) => a.isDefault);
    const activeAddress = billingAddress || defaultAddress;

    if (!activeAddress) {
        return 'NO_ADDRESS';
    }

    // MAIL / POST validation
    if (profile === DocumentSendingProfile.MAIL || profile === DocumentSendingProfile.POST) {
        const isComplete = activeAddress.streetNameAndNumber && activeAddress.city && activeAddress.country;
        if (!isComplete) {
            return 'INCOMPLETE_POSTAL';
        } 
    }

    // E-DOC validation
    if (profile === DocumentSendingProfile.EDOCUMENT) {
        const email = activeAddress.email || activeAddress.b2bDeliveryEmail;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            return 'INVALID_EMAIL';
        }
    }

    return null; // Valid
};

// Expose refs for parent component access
expose({
    tax,
    validateSendingProfile
});



const proxy = getCurrentInstance()?.proxy as any;

const selectedBankAccount = ref(props.bankCode || '');
const selectedIsTaxPayerOption = ref(props.isTaxPayer ? 1 : 0);

const booleanOptions = computed(() => [
    {
        id: 0,
        value: false,
        name: proxy.$t('No'),
    },
    {
        id: 1,
        value: true,
        name: proxy.$t('Yes'),
    },
]);

const documentSendingOptions = computed(() => [
    { 
        id: 1, 
        value: DocumentSendingProfile.MAIL, 
        label: proxy.$t('Mail') 
    },
    { 
        id: 2, 
        value: DocumentSendingProfile.EDOCUMENT, 
        label: proxy.$t('E-document') 
    },
    { 
        id: 3, 
        value: DocumentSendingProfile.POST, 
        label: proxy.$t('Post') 
    },
]);

const currencies = computed(() => CurrencyRepository.getAll());
const paymentTypes = computed(() => PaymentTypeRepository.getAllWithArchived());
const bankAccounts = computed(() => BankAccountRepository.getAllWithFormattedName());

const onSelectedBankAccountChange = (value: string) => {
    selectedBankAccount.value = value;
    const bank = bankAccounts.value.find((b: any) => b.id === value);
    emit('update:bankCode', bank?.accountNumber || '');
};

const onSelectedIsTaxPayerOptionChange = (value: number) => {
    selectedIsTaxPayerOption.value = value;
    emit('update:isTaxPayer', value === 1);
};

watch(
    () => props.bankCode,
    (newVal) => {
        selectedBankAccount.value = newVal || '';
    },
    { immediate: true },
);

watch(
    () => props.isTaxPayer,
    (newVal) => {
        selectedIsTaxPayerOption.value = newVal ? 1 : 0;
    },
    { immediate: true },
);

return { __sfc: true,props, tax, validateSendingProfile, emit, proxy, selectedBankAccount, selectedIsTaxPayerOption, booleanOptions, documentSendingOptions, currencies, paymentTypes, bankAccounts, onSelectedBankAccountChange, onSelectedIsTaxPayerOptionChange }
}

})